<template>
  <div class="complete-wrapper">
    <img class="w-full" :src="brandAsset(complete, completeSanne)" />
  </div>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import complete from '@/assets/ScanBody/complete.svg';
import completeSanne from '@/assets/sanne/scan-complete.svg';

export default {
  name: 'ScanComplete',
  mixins: [brandMode],
  data: () => ({ complete, completeSanne }),
};
</script>

<style lang="scss" scoped>
.complete-wrapper {
  @apply absolute flex justify-center items-center;
  @screen sm {
    width: 200px;
  }
}
</style>
